

<navigation-button
  scsStopPropagation
  (click)="openSmartlist()"
  [indent]="indent">
  <ng-container icon>
    <scs-svg-icon name="list-smart"></scs-svg-icon>
  </ng-container>
  
  {{ list.name }}
</navigation-button>
